<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Ruteador
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Facturación masiva</span>
      <span> /</span>
      <span>Ruteador</span>
    </p>
  </div>
</div>
<form [formGroup]="formFiltrosDocumentos">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">

        <ng-container *ngIf="permiteUnidadNegocio">
          <div class="col" style="max-width: 300px;">
            <div class="md-form">
              <mdb-select label="Unidad de Negocio" [options]="optionsUnidadesDeNegocio" placeholder="Unidad de negocio"
                [filterEnabled]="true" formControlName="unidad_negocio_codigo">
              </mdb-select>
              <div *ngIf="
                      formFiltrosDocumentos.get('unidad_negocio_codigo').invalid &&
                      (formFiltrosDocumentos.get('unidad_negocio_codigo').dirty ||
                      formFiltrosDocumentos.get('unidad_negocio_codigo').touched)
                    ">
                <mdb-error *ngIf="formFiltrosDocumentos.get('unidad_negocio_codigo').hasError('required')">
                  Ingrese unidad de negocio
                </mdb-error>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="col" style="max-width: 200px;">
          <div class="md-form mb-0">
            <mdb-date-picker [options]="myDatePickerOptions" [inline]="true" placeholder="Fecha" id="fechafiltroDesde"
              #fechafiltro formControlName="filtroFechaDesde" required></mdb-date-picker>
            <label>Desde</label>
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form mb-0">
            <mdb-date-picker [options]="myDatePickerOptions" [inline]="true" placeholder="Fecha" id="fechafiltroHasta"
              #fechafiltro formControlName="filtroFechaHasta" required></mdb-date-picker>
            <label>Hasta</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsEstado" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Estado" id="estadofiltro" #estadofiltro formControlName="filtroEstado">
            </mdb-select>
            <label>Estado</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsComuna" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Comuna" id="comunafiltro" #comunafiltro formControlName="filtroComuna">
            </mdb-select>
            <label>Comuna</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsVendedor" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Vendedor" id="vendedorfiltro" #vendedorfiltro formControlName="filtroVendedor">
            </mdb-select>
            <label>Vendedor</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsTerritorios" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Terrirorio" id="territoriofiltro" #territoriofiltro
              formControlName="filtroTerritorio">
            </mdb-select>
            <label>Territorio</label>
          </div>
        </div>

      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div class="resultados pl-2">
        <div class="resultados pl-2">
          <strong>Total Documentos</strong><span class="dummyTxt">{{total_documentos}}</span>
          <strong>Documentos asignados</strong><span class="dummyTxt">{{documentos_entregados}}</span>
          <strong>Documentos pendientes</strong><span class="dummyTxt">{{documentos_pendientes}}</span>
          <strong>Clientes</strong><span class="dummyTxt">{{numeros_clientes}}</span>
        </div>
      </div>
      <div>
        <button mdbBtn type="submit" color="secondary" size="sm" mdbWavesEffect (click)="buscarPorFiltros()"
          [disabled]="loadingBusqueda">
          <mdb-icon *ngIf="!loadingBusqueda" fas icon="search"></mdb-icon>
          <div *ngIf="loadingBusqueda" class="spinner-border spinner-border-sm text-white" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          {{ loadingBusqueda ? 'Buscando...' : 'Buscar' }}
        </button>
        <button mdbBtn type="submit" color="secondary" size="sm" mdbWavesEffect (click)="limpiarFiltros()">
          Limpiar
        </button>
      </div>
    </div>
  </div>

</form>



<div class="card mb-2 wow detalle-cliente">
  <div class="card-body">
    <!-- MAPA -->
    <div class="row filtros-body">
      <div class="col">
        <div class="table-responsive position-relative">
          <!-- Overlay de carga para el mapa -->
          <div *ngIf="loadingBusqueda"
            class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
            style="background-color: rgba(255,255,255,0.8); z-index: 1000; top: 0; left: 0;">
            <div class="text-center">
              <div class="spinner-border text-primary mb-3" role="status">
                <span class="sr-only">Cargando...</span>
              </div>
              <p class="text-muted mb-0">Buscando documentos...</p>
            </div>
          </div>

          <agm-map id="map" (mapReady)="onMapReady($event)" [styles]="customStyle" [latitude]="defaultLatitude"
            [longitude]="defaultLongitude" [zoom]="defaultZoom" (mapClick)="close_previous_info_window()">
            <agm-marker in *ngFor="let b of beaches; let i = index" [latitude]="b.latitud" [longitude]="b.longitud"
              [iconUrl]="b.iconUrl" [label]="b.label" [markerDraggable]="b.draggable"
              (markerRightClick)="onMarkerRightClick(b)" (markerClick)="select_marker(infoWindow)">
              <agm-info-window #infoWindow>
                <div class="info-window">
                  <h3>{{ b.info.title }}</h3>
                  <p>{{ b.info.description }}</p>
                  <p><strong>Dirección:</strong> {{ b.info.address }}</p>
                  <p><strong>Comuna:</strong> {{ b.info.comuna }}</p>
                  <p><strong>Folios:</strong> {{ b.info.documento }}</p>
                  <p><strong>Cajas:</strong> {{ b.info.caja }}</p>
                  <p><strong>Unidad:</strong> {{ b.info.unidad }}</p>
                  <p><strong>Peso:</strong> {{ b.info.peso }}</p>
                  <p><strong>Volumen:</strong> {{ b.info.volumen }}</p>
                </div>
              </agm-info-window>
            </agm-marker>
          </agm-map>
        </div>
      </div>
    </div>
    <div class="row filtros-body justify-content-end mt-2" *ngIf="listaDocumentoAsignado.length > 0">
      <div class="col-12 col-md-6">
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col"></th>
              <th scope="col" class="text-right">Cajas</th>
              <th scope="col" class="text-right">Unidad</th>
              <th scope="col" class="text-right">Peso</th>
              <th scope="col" class="text-right">Volumen</th>
              <th scope="col" class="text-right">Monto</th>
              <th scope="col" class="text-right">Documentos</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td scope="col"><strong>Totales</strong></td>
              <th class="text-right">{{sumTotalCajas | numerico}}</th>
              <th class="text-right">{{sumTotalUnidad | numerico}}</th>
              <th class="text-right">{{sumTotalPeso | numerico}}</th>
              <th class="text-right">{{sumTotalVolumen | numerico}}</th>
              <th class="text-right">{{sumTotalMonto | numerico}}</th>
              <th class="text-right">{{sumTotalDocumentos | numerico}}</th>
            </tr>
            <tr>
              <td scope="col"><strong>Seleccionados</strong></td>
              <th class="text-right">{{sumCajasSelect | numerico}}</th>
              <th class="text-right">{{sumUnidadSelect | numerico}}</th>
              <th class="text-right">{{sumPesoSelect}}</th>
              <th class="text-right">{{sumVolumenSelect}}</th>
              <th class="text-right">{{sumMontoSelect | numerico}}</th>
              <th class="text-right">{{listadoSeleccionadosAsignados.length | numerico}}</th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row filtros-body">
      <div class="col" style="max-width:100%;">
        <div class="md-form">
          <button class="float-right" color="info" mdbBtn type="button" size="sm" mdbWavesEffect data-toggle="modal"
            data-target="#dvModalAsignarCamionRutas" (click)="showModalAsignarAutomaticaCamionRutas()"
            mdbTooltip="Asignar Automática Camión" placement="right">
            Asignación Automática
          </button>

          <button class="float-right" color="info" mdbBtn type="button" size="sm" mdbWavesEffect data-toggle="modal"
            data-target="#dvModalAsignarCamionRutas" (click)="showModalAsignarCamionRutas()" mdbTooltip="Asignar Camión"
            placement="right">
            Asignar
          </button>
          <button class="float-right" color="info" mdbBtn type="button" size="sm" mdbWavesEffect data-toggle="modal"
            data-target="#dvModalAsignarCamionRutas" (click)="showModalverAddEditRutasModal()" placement="right">
            Crear Ruta
          </button>
          <button class="float-right" color="info" mdbBtn type="button" size="sm" mdbWavesEffect data-toggle="modal"
            data-target="#dvModalAsignarCamionRutas" (click)="showModalAsignarCamionRutas(true)"
            mdbTooltip="Editar Rutas" placement="right">
            Editar Rutas
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <form [formGroup]="formFiltrosDocumentos">
      <div class="card-body justify-content-between">

        <div class="row  filtros-body">
          <div class="col">
            <div class="row">
              <div class="col" style="max-width: 150px;">
                <div class="md-form">
                  <mdb-date-picker [options]="myDatePickerOptions" [inline]="true" placeholder="Fecha"
                    id="fechafiltroDetalleRecorrido" #fechafiltro formControlName="fechafiltroDetalleRecorrido"
                    required>

                  </mdb-date-picker>
                  <label>Desde</label>
                </div>
              </div>
              <div class="col" style="max-width: 150px;">
                <div class="md-form mb-0">
                  <mdb-date-picker [options]="myDatePickerOptions" [inline]="true" placeholder="Fecha"
                    id="fechafiltroDetalleRecorridoHasta" #fechafiltro
                    formControlName="fechafiltroDetalleRecorridoHasta" required></mdb-date-picker>
                  <label>Hasta</label>
                </div>

              </div>
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <mdb-select [options]="optionsEstadoDetalle" [multiple]="false" [filterEnabled]="true"
                    placeholder="Seleccionar Estado" [highlightFirst]="false" id="estadofiltroDetalleRecorrido"
                    #estadofiltro formControlName="estadofiltroDetalleRecorrido">
                  </mdb-select>
                  <label>Estado</label>
                </div>
              </div>

            </div>
          </div>
          <div class="col text-right">
            <button mdbBtn type="submit" color="secondary" size="sm" mdbWavesEffect (click)="buscarRecorridos()">
              <mdb-icon fas icon="search"></mdb-icon>
              Buscar
            </button>
          </div>
        </div>

      </div>
    </form>

    <!-- CAMIONES POR CHOFER -->

    <!-- BOTON GENERAR PDF -->
    <div class="d-flex">
      <ng-container *ngIf="!loadingPdf">
        <button mdbBtn type="button" color="primary" mdbWavesEffect
          (click)="ObtenerDataToPdf()" mdbTooltip="Generar PDFs"
          [disabled]="!permiteObtenerPDF()">
          <mdb-icon fas icon="file-pdf"></mdb-icon>
          Generar PDFs ({{listadoCamionChoferSelectCount}})
        </button>
      </ng-container>
      <ng-container *ngIf="loadingPdf">
        <div class="d-flex align-items-center" *ngIf="listadoCamionChoferSelectCount > 0">
          <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
          <strong>{{messageLoading}}</strong>
        </div>
      </ng-container>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">
              <mdb-checkbox *ngIf="existePDFs()" 
                [(ngModel)]="checkAllRecorrido" 
                (change)="checkAllRecorridosChange($event)"
                [checked]="true">
              </mdb-checkbox>
            </th>
            <th scope="col"></th>
            <th scope="col">N° Rec.</th>
            <th scope="col">Patente</th>
            <th scope="col">Chofer</th>
            <th scope="col">N° Docs.</th>
            <th scope="col">Valor $</th>
            <th scope="col">Bultos</th>
            <th scope="col">Vol. C.</th>
            <th scope="col">Vol. A.</th>
            <th scope="col">Dif.</th>
            <th scope="col">Peso C.</th>
            <th scope="col">Peso A.</th>
            <th scope="col">Dif.</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody *ngIf="loadingCamion">
          <tr>
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr *ngFor="let cam of listadoCamionChofer; let i = index"
            [ngClass]="{estadoCamion1:cam.estado == 'En Carga', estadoCamion2: cam.estado == 'Despachado', estadoCamion3: cam.estado == 'Liquidado'}">
            <td>
              <mdb-checkbox *ngIf="cam.codigo_estado != 4 && cam.total_documentos > 0"
                [id]="'checkRecorrido' + i"
                [(ngModel)]="cam.seleccion" 
                (change)="checkRecorridoChange(i, $event)">
              </mdb-checkbox>
            </td>
            <td (click)="showModalVerDetalleCamionChofer(cam)" [style.backgroundColor]="cam.color">{{''}}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.correlativo }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.patente }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.nombre_chofer }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.total_documentos | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">$ {{ cam.total_facturas | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)"> {{cam.total_bultos}} </td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.volumen_maximo_camion | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.volumen_maximo_recorrido | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.diferencia_volumen | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.peso_maximo_camion | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.peso_maximo_recorrido | numerico }}</td>
            <td (click)="showModalVerDetalleCamionChofer(cam)">{{ cam.diferencia_peso | numerico }}</td>
            <td *ngIf="cam.codigo_estado != 4 && cam.total_documentos > 0">
              <button class="btn-actions-sm" [disabled]="cam.despachado" color="success" mdbBtn type="button"
                mdbWavesEffect (click)="despacharRecorrido(cam)" mdbTooltip="Despachar" placement="right">
                <mdb-icon fas icon="luggage-cart"></mdb-icon>
              </button>
              <button class="btn-actions-sm" color="dark" mdbBtn type="button" size="sm" mdbWavesEffect
                data-toggle="modal" data-target="#dvModalmostarRutas" (click)="showModalmostrarRutas(cam)"
                mdbTooltip="Mostrar Rutas" placement="right">
                <mdb-icon fas icon="map-marked-alt"></mdb-icon>
              </button>
              <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
                data-toggle="modal" data-target="#dvModalVerDetalleCamion"
                (click)="showModalVerDetalleCamionChofer(cam)" mdbTooltip="Ver detalle" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
              <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                [disabled]="cam.despachado" (click)="eliminarRecorrido(cam)" mdbTooltip="Liberar" placement="right">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <!-- boton para descargar un pdf -->
              <!-- <ng-container *ngIf="!cam.loadingPdf">
                <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                  (click)="showModalPdf_data(cam)" mdbTooltip="Generar PDFs" placement="right">
                  <mdb-icon fas icon="file-pdf"></mdb-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="cam.loadingPdf">
                <mdb-spinner spinnerColor="blue" spinnerType="small"></mdb-spinner>
              </ng-container> -->

              <button class='btn btn-info btn-actions-sm' mdbBtn type="button" mdbWavesEffect
                (click)='showModalExcel_data(cam)' mdbTooltip='Generar Listado de Carga' placement='top'>
                <mdb-icon fas icon='file-excel'></mdb-icon>
              </button>
            </td>
            <td *ngIf="cam.codigo_estado == 1 && cam.total_documentos == 0">
              <!-- EDITAR CAMION -->
              <button class='btn btn-info btn-actions-sm' mdbBtn type="button" mdbWavesEffect
                (click)='showModalEditarRutasModal(cam)'>
                <mdb-icon fas icon='edit'></mdb-icon>
              </button>

              <!-- ELIMINAR CAMION -->
              <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                (click)="eliminarCamion(cam)">
                <mdb-icon fas icon="trash"></mdb-icon>
              </button>

            </td>
          </tr>
          <tr *ngIf="listadoCamionChofer.length==0">
            <td colspan="100%" style="text-align: center">No se encontraron resultados.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="MdbColorEstado">
      <div class="mb-2 wow">
        <div class="col">
          <div class="row">
            <div style="width: 10%;">
              <input disabled value="" type="text" class="mdFormInput form-control estadoCamion3" readonly />
              <label class="mdFormLabel"> Liquidado</label>
            </div>
            <div style="width: 10%;">
              <input disabled value="" type="text" class="mdFormInput form-control estadoCamion2" readonly />
              <label class="mdFormLabel"> Despachado</label>
            </div>
            <div style="width: 10%;">
              <input disabled value="" type="text" class="mdFormInput form-control estadoCamion1" readonly />
              <label class="mdFormLabel"> En Carga</label>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div id="info" style="display: none;">
</div>

<!-- MODAL DETALLE DOCUMENTO -->
<div style="overflow-y: auto;" mdbModal #verDetalleCamionChofer="mdb-modal" class="modal fade"
  id="dvModalVerDetalleCamion" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <ng-container *ngIf="listadoDetalleDocumentos && recorridoDetalleSeleccionado">
    <div class="modal-dialog modal-fluid" style="width: 80%;" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Detalle Documento
            <div class="resultados">
              <strong>Recorrido</strong><span class="dummyTxt">{{recorridoDetalleSeleccionado.recorrido_codigo}}</span>
              <strong>Fecha</strong><span class="dummyTxt">{{recorridoDetalleSeleccionado.fecha | date}}</span>
              <strong>Despacho</strong><span class="dummyTxt">{{recorridoDetalleSeleccionado.fecha | date}}</span>
              <strong>Patente</strong><span class="dummyTxt">{{recorridoDetalleSeleccionado.patente}}</span>
              <strong>Chofer</strong><span class="dummyTxt">{{recorridoDetalleSeleccionado.nombre_chofer}}</span>
              <strong>Estado</strong><span class="dummyTxt">{{recorridoDetalleSeleccionado.estado}}</span>
            </div>
          </h4>

          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="verDetalleCamionChofer.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body" style="overflow-y: scroll;">


          <div class="table-responsive">
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="grey lighten-2">
                <tr>
                  <mdb-checkbox name="detalle-all" *ngIf="!recorridoDetalleSeleccionado.despachado"
                    [checked]="listadoDetalleCamionChofer.length === listadoDetalleDocumentos.length"
                    (change)="checkAll($event)">
                  </mdb-checkbox>
                  <th scope="col" style="max-width: 30px;">N° Doc.</th>
                  <th scope="col">Nombre Cliente</th>
                  <th scope="col">Vendedor</th>
                  <th scope="col">Direccion</th>
                  <th scope="col">Comuna</th>
                  <th scope="col">Cajas</th>
                  <th scope="col">Monto Total</th>
                  <th scope="col" style="width: 120px;">Prioridad</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loadingDetalles">
                  <td colspan="100%" style="text-align: center">
                    <mdb-spinner spinnerColor="blue"></mdb-spinner>
                  </td>
                </tr>
                <tr *ngIf="!loadingDetalles && listadoDetalleCamionChofer?.length === 0">
                  <td colspan="100%" style="text-align: center">
                    No se encontró información
                  </td>
                </tr>
                <tr *ngFor="let detCam of listadoDetalleCamionChofer">
                  <mdb-checkbox name="detalle-{{detCam.numero_documento}}"
                    *ngIf="!recorridoDetalleSeleccionado.despachado" [checked]=isChecked(detCam.numero_documento)
                    (change)=checkHandle($event,detCam)>
                  </mdb-checkbox>
                  <td>{{ detCam.numero_documento }}</td>
                  <td>{{ detCam.nombre_cliente }}</td>
                  <td>{{ detCam.vendedor_nombre }}</td>
                  <td>{{ detCam.direccion_completa }}</td>
                  <td>{{ detCam?.comuna_despacho }}</td>
                  <td>{{ detCam.cajas | numerico}}</td>
                  <td>$ {{ detCam.total_documentos | numerico }}</td>
                  <td>
                    <app-numeric-input [value]="getPrioridadValue(detCam.prioridad)" [min]="0" [max]="10" [step]="1"
                      size="sm" (valueChange)="onPrioridadChange($event, detCam)"
                      [disabled]="recorridoDetalleSeleccionado.despachado">
                    </app-numeric-input>
                  </td>
                  <td>
                    <!-- <button [isDisabled]="recorridoDetalleSeleccionado.despachado"
                          *ngIf="!recorridoDetalleSeleccionado.despachado"
                          class="btn-actions-xxs" color="{{recorridoDetalleSeleccionado.despachado? 'default': 'primary'}}" mdbBtn type="button" mdbWavesEffect
                          [disabled]="detCam.despachado" (click)="eliminarRecorridoDetalle(detCam)" mdbTooltip="Eliminar">
                    <mdb-icon  class="fa-sm" fas icon="ban"></mdb-icon>
                  </button> -->
                  </td>
                </tr>
              </tbody>
              <app-pagination [context]="paginationContextDetalles" (onPageChange)="onPageChangeDetalles($event)"
                *ngIf="listadoDetalleCamionChoferAll?.length > 0"></app-pagination>
            </table>

          </div>

          <div class="row">
            <div class="col">
              <div class="resultados mb-2">
                <strong>Docs.</strong><span class="dummyTxt">{{listadoDetalleCamionChofer?.length > 0 ? sumaDocumentos()
                  : 0}}</span>
                <strong>Cajas</strong><span class="dummyTxt">{{listadoDetalleCamionChofer?.length > 0 ? sumaCajas() :
                  0}}</span>
                <strong>Vol.</strong><span class="dummyTxt">{{(listadoDetalleCamionChofer?.length > 0 ? sumaVolumen() :
                  0) | numerico}}</span>
                <strong>Monto</strong><span class="dummyTxt">$ {{(listadoDetalleCamionChofer?.length > 0 ? sumaMonto() :
                  0) | numerico}}</span>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-between w-100">
            <div class="left-buttons">
              <button type="button" class="btn btn-sm btn-default waves-light" size="sm" data-dismiss="modal"
                (click)="verDetalleCamionChofer.hide()" mdbWavesEffect>
                Cerrar
              </button>
            </div>


            <div class="center-buttons">
              <ng-container *ngIf="listadoDetalleDocumentos.length >= 1">
                <button [isDisabled]="recorridoDetalleSeleccionado.despachado" mdbBtn type="button"
                  class="btn btn-sm btn-primary waves-light me-2"
                  color="{{recorridoDetalleSeleccionado.despachado? 'default': 'primary'}}" size="sm"
                  (click)="!recorridoDetalleSeleccionado.despachado ? eliminarRecorridoDetalleList() : null"
                  mdbWavesEffect>
                  Liberar
                </button>

                <button [isDisabled]="recorridoDetalleSeleccionado.despachado" mdbBtn type="button"
                  class="btn btn-sm btn-primary waves-light"
                  color="{{recorridoDetalleSeleccionado.despachado? 'default': 'primary'}}" size="sm"
                  (click)="!recorridoDetalleSeleccionado.despachado ? ReAsignarRecorridoDetalleList() : null"
                  mdbWavesEffect>
                  Reasignar
                </button>
              </ng-container>
            </div>

            <div class="right-buttons">
              <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect class="btn btn-sm me-2"
                (click)="downloadExcelPdf('XLS', recorridoDetalleSeleccionado)">
                Excel
              </button>

              <button class='btn btn-info' mdbBtn type="button" size="sm" mdbWavesEffect (click)='guardarPrioridades()'
                mdbTooltip='Guardar Prioridades' placement='top'>
                <mdb-icon fas icon='save'></mdb-icon>
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

</div>


<!-- MODAL MOSTRAR RUTA DEL CAMION A LOS PUNTOS -->
<app-modal-rutas-camion (onCerrar)="onCerrarRutaModal($event)"></app-modal-rutas-camion>

<!-- MODAL RUTAS DIVIDIDAS (Cuando hay más de 25 puntos) -->
<app-modal-rutas-divididas (onMostrarRuta)="onMostrarRutaDesdeDivididas($event)"
  #modalRutasDivididas></app-modal-rutas-divididas>

<!-- MODAL ASIGNAR CAMIONES -->
<ruteador-modal-asignar (onSuccess)="onCamionAsignado()" queryType="RUTEADOR" [events]="eventsSubject.asObservable()"
  (onShowModalRutasRequest)="showModalverAddEditRutasModal()" (onActualizarListaChoferes)="onCargarRuta()"
  (contextmenu)="onRightClick($event)">
</ruteador-modal-asignar>

<!-- MODAL ASIGNAR AUTOMATICA DE CAMIONES -->
<ruteador-modal-asignar-automatica (onSuccess)="onCamionAutomaticaAsignado()"
  (onShowModalRutasRequest)="showModalverAddEditRutasModal()" (onActualizarListaChoferes)="onCargarRuta()">
</ruteador-modal-asignar-automatica>

<!-- MODAL ADD/EDIT RUTA -->
<app-modal-add-edit-ruta (onSuccess)="onCargarRuta()" (onShowModalRutasRequest)="showModalverAddEditRutasModal()">
</app-modal-add-edit-ruta>

<!-- MODAL CONFIRMACION -->
<app-modal-confirm title="{{ tittle }}" contentText="{{message}}"></app-modal-confirm>

<!-- MODAL OPCIONES DEL MARCADOR -->
<app-modal-opciones-asignacion title="{{ tittle }}" contentText="{{message}}"
  (contextmenu)="onRightClick($event)"></app-modal-opciones-asignacion>


<!--RESULTADO DE LA SELECCION EN EL POLIGONO-->
<app-modal-resultado-asignacion (onAsignar)="showModalverAddEditRutasResultado()"
  (contextmenu)="onRightClick($event)"></app-modal-resultado-asignacion>